<fi-header [profileData]="profileData | async" [adminMandant]="adminMandant"></fi-header>

<div class="main-content">
  <div class="main-content-inner">
    <router-outlet></router-outlet>
  </div>
</div>

<div id="overlay"></div>
